

export function typeofs(obj) {
    var regexp = /\s(\w+)\]/;
    return regexp.exec(Object.prototype.toString.call(obj))[1];
  
}